import React from "react";

import AlbumPhotoCard from "./AlbumPhotoCard";

import "./AlbumPhotoGrid.css";

export default function AlbumPhotoGrid({
  images = [],
  onPhotoClick,
  disabled = false,
  className = "",
}) {
  const photos = Array.isArray(images) ? images : [];

  if (!photos.length) return null;

  return (
    <div className={`album-photo-grid ${className}`.trim()}>
      {photos.map((image, index) => (
        <AlbumPhotoCard
          key={image?.imageId ?? image?.imageTag ?? index}
          image={image}
          index={index}
          onClick={onPhotoClick}
          disabled={disabled}
        />
      ))}
    </div>
  );
}
